import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import framework from '_c/framework';
import Person from './person';
import { getStaffInfoByUserids } from 'api/common';
export default {
  components: {
    Person: Person,
    framework: framework
  },
  props: {
    // 原对象
    nodeData: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    // 默认要原对象修改的值
    valueKey: {
      default: 'val',
      type: String
    },
    control: {
      type: Object,
      default: function _default() {
        return {
          all: 0,
          depShow: 2,
          staffShow: 1
        };
      }
    }
  },
  data: function data() {
    return {
      // 选人组件是否展示
      approverVisible: false,
      // 已选列表
      nodeUserList: []
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    // 获取已选员工
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var val, staffIds, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              val = _this.nodeData[_this.valueKey];
              if (!Array.isArray(val)) {
                _context.next = 9;
                break;
              }
              staffIds = val.map(function (item) {
                return item.id || '';
              });
              if (val.length) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", false);
            case 5:
              _context.next = 7;
              return getStaffInfoByUserids({
                staff_ids: staffIds
              });
            case 7:
              res = _context.sent;
              _this.nodeUserList = res.data.staff_list;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addApprover: function addApprover() {
      this.approverVisible = true;
    },
    /**
     * 删除单个选中项
     * @param { number } index 下标
     */
    removeEle: function removeEle(index) {
      this.nodeUserList.splice(index, 1);
      this.onSave(this.nodeUserList);
    },
    onEmpty: function onEmpty() {
      this.nodeUserList = [];
      this.nodeData[this.valueKey] = [];
    },
    /**
     * 存储已选项
     * @param { Array } staffList 员工列表
     */
    onSave: function onSave(staffList) {
      this.nodeData[this.valueKey] = staffList.map(function (item) {
        return {
          id: item.staff_id,
          label: item.staff_name
        };
      });
    },
    /**
     * 人员选择确认
     * @param {*} params 已选项
     */
    sureApprover: function sureApprover(params) {
      // 添加到选中列表
      this.nodeUserList = params.staff_list;
      this.onSave(params.staff_list);
      this.approverVisible = false;
    }
  }
};